import React from "react";

import { cn } from "../../../common/u1/cn";
import { Aed } from "../../../common/Money";
import {
  MEMBERSHIP_ANNUAL,
  MEMBERSHIP_MONTHLY,
  PLAN_MONTHLY,
  PLAN_YEARLY,
} from "../../../../constants/webProfilePricing";

/* Annual or monthly, inside the bundle card. */
const TERMS = [
  {
    plan: PLAN_YEARLY,
    label: "Annual",
    price: MEMBERSHIP_ANNUAL,
    suffix: "/ yr",
    ribbon: "Save 2 months",
  },
  {
    plan: PLAN_MONTHLY,
    label: "Monthly",
    price: MEMBERSHIP_MONTHLY,
    suffix: "/ mo",
  },
];

export const MembershipTermToggle = ({ value, onChange, className = "" }) => (
  <div className={cn("grid grid-cols-2 gap-2", className)}>
    {TERMS.map((term) => {
      const selected = value === term.plan;
      return (
        <button
          key={term.plan}
          type="button"
          aria-pressed={selected}
          onClick={(e) => {
            /* The card around this is a label; without this the click would
               also reach its radio. Harmless today — both paths select the
               bundle — but it keeps the two from racing. */
            e.stopPropagation();
            onChange?.(term.plan);
          }}
          className={cn(
            "relative rounded-[12px] border p-3 text-left transition-colors",
            term.ribbon ? "pt-7" : "pt-3",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--orange)]",
            selected
              ? "border-[var(--coral)] bg-[var(--coral-soft)]"
              : "border-[var(--line)] bg-white hover:border-[var(--line-2)]"
          )}
        >
          {term.ribbon && (
            <span
              className={cn(
                "absolute right-1.5 top-1.5 rounded bg-[var(--navy)] px-1.5 py-1",
                "text-[9.5px] font-bold uppercase leading-none tracking-[.06em] text-white font-sans"
              )}
            >
              {term.ribbon}
            </span>
          )}
          <p className="m-0 text-[13.5px] font-bold text-[var(--ink)] font-sans">
            {term.label}
          </p>
          <p className="m-0 mt-0.5 text-[12px] text-[var(--muted)] font-sans">
            <Aed value={term.price} /> {term.suffix}
          </p>
        </button>
      );
    })}
  </div>
);

export default MembershipTermToggle;
